import './chunk-6ea13200.js';
import './helpers.js';
import './chunk-17222463.js';
import './chunk-1f14bcfd.js';
import './chunk-d732d84c.js';
import { r as registerComponent, u as use } from './chunk-cca88db8.js';
import './chunk-322704a2.js';
import './chunk-bee4013f.js';
import './chunk-42f463e6.js';
import './chunk-757e4793.js';
import './chunk-f3c004c8.js';
import './chunk-4ecafae5.js';
import { T as Timepicker } from './chunk-faa5b64f.js';
export { T as BTimepicker } from './chunk-faa5b64f.js';

var Plugin = {
  install: function install(Vue) {
    registerComponent(Vue, Timepicker);
  }
};
use(Plugin);

export default Plugin;
